import {FormattedMessage} from 'react-intl';
const Loading = () => {
    return (
        <div className="loading-overlay">
                    <div className="spinner"></div>
                    <FormattedMessage id="Loading"/>
                    </div>
    );
  };
export default Loading;